<template>
    <el-collapse-transition>
        <div class="sublistwrap" v-show="courseinfo.x_isopen">
            <div class="sublist" v-for="item in courseinfo.x_children" :key="item.id">
                <dl v-if="item.courseinfotypekv==1" :title="$common.langinfo( item.title,item.title_en)" @click="showdetail(item.id)">
                    <dt><ffoverdot :title="item.title" :title_en="item.title_en"></ffoverdot></dt>
                    <dd class="open"><i class="iconfont icon-zhankai" :style="{transform: 'rotate('+(item.x_isopen?'180':'0')+'deg)'}"></i></dd>
                </dl>

                <dl :class="['courselink',item.id==curid?'cs':'']" v-else :title="$common.langinfo( item.title,item.title_en)" @click="showdetail(item.id)">
                    <dd class="a">
                        <span class="circle">
                            <span v-if="item.x_perc==0" class="ready"></span>
                            <span v-else-if="item.x_perc==100" class="done"></span>
                            <template v-else>
                                <span class="doing" :style="{transform: 'rotate('+(item.x_perc*3.6)+'deg)'}"></span>
                                <span :class="[item.x_perc<=50?'fanless':'fanmore']"></span>
                            </template>
                        </span>
                    </dd>
                    <dd class="b">
                        <i :class="['iconfont',item.courseinfotypekv==101? 'icon-jiaoxueziyuante':item.courseinfotypekv==102?'icon-mp1':'icon-zuoye']"></i>
                        <ffoverdot :title="item.title" :title_en="item.title_en"></ffoverdot>
                    </dd>
                    <dd class="c" v-if="item.courseinfotypekv==101">
                        {{$common.dicword('learntimes',true)}}{{item.x_learncount}}
                        <template v-if="firstid!=item.id && $store.getters.isstu">
                            /{{item.x_maxlearn}}
                        </template><span class="myspace"></span>{{$common.dicword('pagecount',true)}}{{item.x_imgs.length}}
                    </dd>
                    <dd class="c" v-if="item.courseinfotypekv==102">
                        {{$common.dicword('learntimes',true)}}{{item.x_learncount}}
                        <template v-if="firstid!=item.id && $store.getters.isstu">
                            /{{item.x_maxlearn}}
                        </template><span class="myspace"></span>{{$common.dicword('duration',true)}}{{$common.basic.chint2timewithsecond(item.duration)}}
                    </dd>

                </dl>
                <Ccoursetree v-if="item.courseinfotypekv==1" :courseinfo="item" :curid="curid" :firstid="firstid" @showdetail="showdetail"></Ccoursetree>
            </div>

        </div>

    </el-collapse-transition>
</template>

<script>
    export default {
        name: 'Ccoursetree',
        props: {
            curid: {
                type: Number,
                default: 0
            },
            firstid: {
                type: Number,
                default: 0
            },
            courseinfo: {
                type: Object,
                default: () => { }
            }
        },
        methods: {
            showdetail: function (v) {
                this.$emit('showdetail', v);
            }
        }
    }
</script>
